<template>
    <div class="container mx-auto max-w-6xl">
        <div class="start-tracking">
            <div v-if="!hideHeader" class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <icon icon="credit-score" class="text-black" />
                    <span class="text-lg font-medium text-slate-800 dark:text-slate-100">
                        Credit Score
                    </span>
                </div>
                <a
                    href="/credit-score/"
                    class="inline-flex items-center rounded text-sm font-medium text-slate-800 dark:text-slate-100 hover:text-slate-700 dark:text-slate-200 active:text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-0"
                    id="hs-credit-score-start-tracking-view-details"
                >
                    View details
                    <icon icon="arrow" />
                </a>
            </div>
            <div class="text-center">
                <div class="flex items-center justify-center mb-2">
                    <img
                        :src="CreditScoreGauge"
                        alt="Credit Score Gauge"
                        class="w-60 h-auto"
                    />
                </div>
                <h2 class="text-3xl font-semibold text-slate-800 dark:text-slate-100 mb-2">
                    Track and improve your
                    <span class="text-orange">credit score</span>
                </h2>
                <p class="text-sm font-normal text-slate-500 dark:text-slate-400 mb-4">
                    Keep your score up to date and see how it changes over
                    time.
                </p>
                <a
                    href="#"
                    class="inline-flex px-4 py-2.5 items-center justify-center rounded bg-orange hover:bg-orange/90 active:bg-orange/80 focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2 shadow-sm"
                    @click.prevent="
                        setActiveScore(null);
                        openCreditScoreModal();
                    "
                    role="button"
                    id="hs-credit-score-start-tracking-add"
                >
                    <span class="font-medium text-sm text-white">
                        Add credit score
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useCreditScoreStore } from '@/store/creditscore';
import Icon from '../ui/icon/icon.vue';
import CreditScoreGauge from '@@/images/creditscore-gauge.svg';

const props = defineProps({
    onDashboard: {
        type: Boolean,
        default: false,
    },
    hideHeader: {
        type: Boolean,
        default: false,
    },
});

const creditScoreStore = useCreditScoreStore();
const { userScoreData } = storeToRefs(creditScoreStore);
const { setTabState, setActiveScore, openCreditScoreModal } = creditScoreStore;
</script>
